/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentCycleCheckListItem from './treatment-cycle-check-list-item';
import TreatmentCycleCheckListItemDetail from './treatment-cycle-check-list-item-detail';
import TreatmentCycleCheckListItemUpdate from './treatment-cycle-check-list-item-update';
import TreatmentCycleCheckListItemDeleteDialog from './treatment-cycle-check-list-item-delete-dialog';

const TreatmentCycleCheckListItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentCycleCheckListItem />} />
    <Route path="new" element={<TreatmentCycleCheckListItemUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentCycleCheckListItemDetail />} />
      <Route path="edit" element={<TreatmentCycleCheckListItemUpdate />} />
      <Route path="delete" element={<TreatmentCycleCheckListItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentCycleCheckListItemRoutes;
